/* eslint-disable @typescript-eslint/no-unsafe-call */
import { StrictMode as ReactStrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

createRoot(document.getElementById("root")!).render(
    <ReactStrictMode>
        <App />
    </ReactStrictMode>
);
